import * as React from 'react'
import { Page } from '@pareto-engineering/design-system'
import ConversionFormContextProvider from './ConversionFormContextProvider'
import { FixedConversionForm } from './index'

const ConversionPage = ({
  conversionFormConfig,
  children,
  desktopLaunchText,
  mobileLaunchText,
  desktopButtonText,
  mobileButtonText,
  disableNav,
  overrideGridProps,
  ...props
}) => {
  const optionalPropsWithValues = Object
    .entries({
      desktopLaunchText,
      mobileLaunchText,
      desktopButtonText,
      mobileButtonText,
      disableNav,
      overrideGridProps,
    })
    .reduce((acc, [k, v]) => (v ? { ...acc, [k]: v } : acc), {})

  return (
    <ConversionFormContextProvider sectionMap={conversionFormConfig}>
      <Page {...props}>
        {children}
        <FixedConversionForm
          {...optionalPropsWithValues}
        />
      </Page>
    </ConversionFormContextProvider>
  )
}

export default ConversionPage
